import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { NextPrevArrow } from "../../helper/Icons";

function LotterySlider({ sectionHeading, icon, data }) {
  const swiperRef = useRef(null);

  return (
    <div className="wrapper mx-auto my-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-white fs-22 fw-bold m-0">
          <span className="opacity-50 me-2">{icon}</span>
          {sectionHeading}
        </h2>
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn bg-darkslate max-w-h-33 d-flex p-1"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <NextPrevArrow />
          </button>
          <button
            className="btn bg-darkslate rotate-180 max-w-h-33 d-flex p-1"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <NextPrevArrow />
          </button>
        </div>
      </div>
      <Swiper
        modules={[Autoplay, Navigation]}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
        slidesPerView={1.2}
        loop={true}
        spaceBetween={8}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        breakpoints={{
          475: {
            slidesPerView: 2.3,
            spaceBetween: 16,
          },
          640: {
            slidesPerView: 2.6,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3.2,
          },
          850: {
            slidesPerView: 3.8,
          },
          1024: {
            slidesPerView: 4.4,
          },
          1280: {
            slidesPerView: 5,
          },
        }}
        className="mySwiper"
      >
        {data.map((data, index) => (
          <SwiperSlide key={index}>
            <div
              style={{
                background: `linear-gradient(131deg, #343837 1.3%, ${data.bgColor} 100.53%)`,
              }}
              className={`position-relative overflow-hidden max-w-245 rounded-3 border-ebonyclay text-white p-3`}
            >
              <div className="w-100 max-w-h-77 position-absolute top-0 end--12">
                <img src={data.img} alt="Country Img" className="img-fluid" />
              </div>
              <div className="border-0 border-bottom">
                <h5 className="fs-16 fw-medium max-w-120 mb-1">
                  {data.heading}
                  <span> {data.run}</span>
                </h5>
                <p className="fs-16 fw-bold fst-italic mb-1">{data.price}</p>
              </div>
              <div>
                <p className="fs-12 my-1">{data.pera}</p>
                <div className="d-flex gap-1 mb-3">
                  <span className="bg-white90 w-100 text-center rounded-2 fs-12 fw-medium py-1">
                    {data.hh} h
                  </span>
                  <span className="fs-18 fw-medium">:</span>
                  <span className="bg-white90 w-100 text-center rounded-2 fs-12 fw-medium py-1">
                    {data.mm}m
                  </span>
                  <span className="fs-18 fw-medium">:</span>
                  <span className="bg-white90 w-100 text-center rounded-2 fs-12 fw-medium py-1">
                    {data.ss}s
                  </span>
                </div>
                <Link
                  to={"/"}
                  className="d-block text-center text-white fw-medium text-decoration-none rounded-2 bg-cherrygradient hover-bg-cherrygradient py-1"
                >
                  Bet Now
                </Link>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default LotterySlider;
